// eslint-disable-next-line no-shadow
export enum NewsletterResponse
{
    DISMISSED = 'dismissed',
    ACCEPTED = 'accepted',
}
